module.exports = __webpack_public_path__ + "35b07eb2f8711ae08d1f58c043880930.woff";